import {
  React,
  Component,
  withCookies,
} from 'imports/CommonImports';

import {Forbidden} from 'imports/ComponentsImports';

// Authorization HOC
const Authorization = (allowedRoles) => (WrappedComponent) =>
{
  return withCookies((class WithAuthorization extends Component {
    constructor(props) {
      super(props)
      this.state = {
        user: this.props.cookies.get('user')
      }
    }
    render() {
      let role = '';
      if(this.state.user)
        role = this.state.user.position
      if (allowedRoles.includes(role) || allowedRoles[0] === 'Anyone') {
        return(<WrappedComponent {...this.props} />)
      } else {
        return(<Forbidden />)
      }
    }
  }))
}

export default Authorization;



// WEBPACK FOOTER //
// ./src/components/common/Authorization.js